export default {
  props: ['beforeIconType', 'afterIconType', 'leftSpan', 'rightSpan'],
  computed: {
    assignedBeforeIcon() {
      return this.beforeIconType !== undefined
    },
    assignedAfterIcon() {
      return this.afterIconType !== undefined
    },
    beforeIconStyles() {
      let styles = []
      if (this.leftSpan !== undefined || this.leftSpan !== '') {
        let span = /^\d*\.?\d*(px|vh|vw|vmin)$/.test(this.leftSpan)
          ? this.leftSpan
          : this.leftSpan + 'px'
        let styleKey = ''
        if (this.$store.getters.isRtlDirection) {
          styleKey = 'right'
        } else {
          styleKey = 'left'
        }
        styles.push({
          [styleKey]: span
        })
      }
      return styles
    },
    afterIconStyles() {
      let styles = []
      if (this.rightSpan !== undefined || this.rightSpan !== '') {
        let span = /^\d*px|vh|vw|vmin$/.test(this.rightSpan)
          ? this.rightSpan
          : this.rightSpan + 'px'
        let styleKey = ''
        this.$store.getters.isRtlDirection
          ? (styleKey = 'left')
          : (styleKey = 'right')
        styles.push({
          [styleKey]: span
        })
      }
      return styles
    }
  }
}
